import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild, NgZone, HostListener } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { CollectionView } from "@grapecity/wijmo";
import { FormatsUtil } from "src/app/utils/formats.util";
import * as wjcGrid from "@grapecity/wijmo.grid";
import { StorageService } from "src/app/services/storage.service";
import { CommonUtil, WijimoUtil } from "src/app/utils";
import { takeUntil } from "rxjs/operators";
import { Observable, Subject } from "rxjs";
import { CommonService, ModalWrapperService } from "src/app/services";
import { CommonWarnorconfirmPopupComponent } from "../common-warnorconfirm-popup/common-warnorconfirm-popup.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { MsgConfig } from "src/app/app.messages";
import { PrescriberComponent } from "../../prescriber";
import { v4 as uuid } from 'uuid';

@Component({
    selector: "app-prescriber-result-card",
    templateUrl: "./prescriber-result-card.component.html",
    styles: [],
    standalone: false
})
export class PrescriberResultCardComponent implements OnInit {
    showPrescName: boolean;
    PrescAddress: any;
    @Input() searchTerm: any;
    @Input() index: any;
    prescriberSuggestWJ: CollectionView;
    prescriberSugListCopy: any;
    loading: boolean;
    progressValue: number;
    prescriberResp: boolean;
    required: boolean;
    isPopUp: boolean;
    prescriberSugListSearch: any;
    modelRef: any;
    modelRefWarn: any;
    @Input()
    set PrescriberResultData(prescriberData: any) {
        this.inputData = prescriberData;
        if (this.inputData && this.inputData.PrescriberAddresses) {
            if (this.inputData.PrescriberAddresses.length > 1) {
                this.inputData.PrescriberAddresses.map(value => {
                    if (value["Id"] === this.inputData.primeAddressId) {
                        this.PrescAddress = value;
                    }
                });
            } else {
                this.PrescAddress =  this.inputData.PrescriberAddresses["0"];
            }
        }
    }

    @Input()
    set RouterURL(ru: string) {
        this.routerURL = ru;
    }

    @Input()
    set IsAllToShow(all: boolean) {
        this.isAllToShow = all;
    }

    @Input()
    set ShowOnlyPrescName(prescName: boolean) {
        this.showPrescName = prescName;
    }

    @Input()
    set IsPopUp(ip: boolean) {
        this.isPopUp = ip;
    }
    @Input() PrescriberSuggestFilterFG : FormGroup;
    @Input() searchFrmPage : any;
    
    @Output() SelectedPrescriber = new EventEmitter();
    @Output() GetSelectedPrescriber = new EventEmitter();
    @Output() ClosePrescriberResultModal= new EventEmitter();
    @Output() ClosePatientDrugPage = new EventEmitter();
    @Output() AddNewPrescriber = new EventEmitter();
    inputData: any;
    routerURL: string;
    isAllToShow: boolean;
    prescriberSugList: any;
    prescriberListwjHeaders: any[];
    
    unsubscribe$: Subject<void> = new Subject();
    @ViewChild("prescriberflex") prescriberflex: wjcGrid.FlexGrid;
    popupId = uuid();
    @HostListener("window:keydown", ["$event"])
    keyEventAlt(event: KeyboardEvent) {
      const topPopup = this._commonUtil.getTopPopup();
      if ((topPopup === this.popupId) && this.isPopUp) {
          if (event.which === 27) {
              this.closePrescriberModal();
              event.preventDefault();
          }
        }
    }
    constructor(public _formatsUtil: FormatsUtil, public _storageService: StorageService, private _cdr: ChangeDetectorRef, private ngZone: NgZone,
        private _commonUtil: CommonUtil, private _wijimoUtils: WijimoUtil, private _commonServ: CommonService, private _modalService: ModalWrapperService) {
    }

    ngOnInit() {
        this._commonUtil.open(this.popupId);
        sessionStorage.setItem("fromDrugGrid","true");
        this.patchDefaultValHeaders();
        this._wijimoUtils.wjSavedData$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe(w => {
            if (w && w["WijmoKey"] && w["WijmoKey"] === "prescriberSuggestListWj") {
                this.patchDefaultValHeaders();
            }
        });
        if(this.inputData?.length) {
            this.prescriberSugList = this.prescriberSugListCopy = this.prescriberSugListSearch = this.inputData;
            this.generatePrescriberWijGrid(this.prescriberSugList);
            this.focusFirstGrid();
        }
    }

    async patchDefaultValHeaders() {
        const storedWJ = await this._wijimoUtils.getWJSavedData("prescriberSuggestListWj");
        this.prescriberListwjHeaders = this._wijimoUtils.patchDefHeader("prescriberSuggestListWj", storedWJ);
    }
    selectedPresc(prescriber: string): any {
        this.SelectedPrescriber.emit({ prescriber });
    }

    Init(flex: wjcGrid.FlexGrid) {
        flex.columnHeaders.rows[0].wordWrap = true;
        flex.autoSizeRow(0, true);
        flex.columnHeaders.rows[0].height = 30;    
        flex?.cells.hostElement.addEventListener('keydown', (e) => {
            if (e.key == 'Enter') {
                this.onEnterClick(flex.collectionView["_src"][flex.selection.row],e);
            }
        });
    }

    focusFirstGrid(): void {
        // Need SetTimeout
        setTimeout(() => {
            if (this.prescriberflex && this.prescriberflex?.rows?.length > 0) {
                this.prescriberflex.selection = new wjcGrid.CellRange(this.prescriberflex.selection._row, 0);
                this.prescriberflex.focus();
            }
        },100);
    }
    onEnterClick(grid,e) {
        this.getselectedPrescriberByCheck(grid);
        e?.preventDefault();
    }

    itemFormatter = (panel, r, c, cell) => {
        const row = panel?.rows?.[r];
        if (row?.dataItem) {
            cell.style.color = "#000";
            cell.style.background = "#FFF";
            cell.style.fontWeight = "400";
        }
        if (panel?.cellType === wjcGrid.CellType.Cell && panel.columns[c].binding === "Prescriber Name") {
            if(row?.dataItem && row?.dataItem?.activestatusid != 1 ) {
                cell.style.color = "#000";
                cell.style.background = "linear-gradient(to left, transparent 98%, #cc0033 2%)";
                cell.style.paddingLeft = "12px"
                cell.style.fontWeight = "700";
            } else {
                cell.style.color = "#000";
                cell.style.paddingLeft = "12px"
                cell.style.background = "#FFF";
                cell.style.fontWeight = "700";
            }
        } else {
            cell.style.color = "#000";
            cell.style.paddingLeft = "10px"
            cell.style.background = "#FFF";
            cell.style.fontWeight = "400";
        }
        if (panel.cellType == wjcGrid.CellType.ColumnHeader && r == 0) {
            cell.style.backgroundColor = "#EAEAEA";
            cell.style.color = "#000";
            cell.style.lineHeight = "24px";
            cell.style.fontWeight = "700"
        }
    }
    onRowSingleClick(grid,e){
        var hti = grid.hitTest(e);
        if (hti && hti?.row >=0 && grid?.selectedRows?.length && grid?.selectedRows?.[0]?.dataItem && hti.cellType === 1) {
            let presc = grid.selectedRows[0].dataItem;
            this.getselectedPrescriberByCheck(presc);
        }
    }
    getselectedPrescriberByCheck(presc) {
        if(this.prescriberSugListCopy?.length) {
            let prescriber = this.prescriberSugListCopy.find(val => (val?.prescriberid === presc?.prescriberid));
            if(prescriber && prescriber["fullname"] && (prescriber["activestatusid"] !== 1)) {
                this.getCommonWarnMsg(prescriber);
            } else if(prescriber) {                       
                this.GetSelectedPrescriber.emit(prescriber);
                sessionStorage.removeItem("fromDrugGrid");
                this.generatePrescriberWijGrid(this.prescriberSugListCopy);
                this._cdr.detectChanges();
                if (this.prescriberflex) {
                    this.prescriberflex.select(-1, -1);
                }
            }
        }
    }

    getCommonWarnMsg(item) {
        const patientName = item?.fullname ? ((item?.fullname)?.toUpperCase())?.replace("_", ", ") : "";
        this.modelRefWarn = this._modalService.open(CommonWarnorconfirmPopupComponent, {centered: true, keyboard: false, backdrop: false, windowClass: "large--content"});
        this.modelRefWarn.componentInstance.IsHeaderText = MsgConfig.Inactive_Prescriber;                    
        this.modelRefWarn.componentInstance.warnMsg = "<label><span class='fw-bold'>" + patientName  +"</span></label> is not an active prescriber. Would you like to activate the prescriber?";
        this.modelRefWarn.componentInstance.yesButton = true;
        this.modelRefWarn.componentInstance.noButton = true;
        this.modelRefWarn.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
            if (this.modelRefWarn) {
                this.modelRefWarn.close();
                this.modelRefWarn = null;
            }
            if(resp) {
                this.ngZone.run(() => {
                    const modalRef = this._modalService.open(PrescriberComponent, {
                        backdrop: false,
                        size: "lg",
                        windowClass: "md-xx-lg comp--modal modal-center-to-page modal-patient comp--modal2",
                        keyboard: false
                    });
                    modalRef.componentInstance.prescriberID = +item?.prescriberid;
                    modalRef.componentInstance.ClosePrescriberModal.pipe(takeUntil(this.unsubscribe$)).subscribe(resp => {
                        if(modalRef){
                            modalRef.close();
                        }
                        if(resp?.Type === "Update") {
                            this.getGlobalSearchPrescriberSuggest();
                        }                           
                    });
                });
            }
        });
    }
    getPrescriberBySearch(){
        let prescriberName = this.PrescriberSuggestFilterFG.value['PrescriberName'];
        if(prescriberName?.length > 2) this.required = false;
        if (prescriberName && this.prescriberSugListSearch?.length) {
            prescriberName = prescriberName ? (prescriberName + '')?.toLowerCase()?.trim() : "";                    
                this.prescriberSugList = this.prescriberSugListSearch?.filter((item: any) => {
                    item["prescriberfirstname"] = item["prescriberfirstname"] ? ((item["prescriberfirstname"] + '')?.toLowerCase()) : "";
                    item["prescriberlastname"] = item["prescriberlastname"] ? ((item["prescriberlastname"] + '')?.toLowerCase()) : "";
                    item["prescriberemail"] = item["prescriberemail"] ? ((item["prescriberemail"] + '')?.toLowerCase()) : "";
                    item["prescribernpinum"] = item["prescribernpinum"] ? item["prescribernpinum"] : "";
                    item["prescriberquickcode"] = item["prescriberquickcode"] ? item["prescriberquickcode"] : "";
                    item["prescriberdeanum"] = item["prescriberdeanum"] ? item["prescriberdeanum"] : "";
                    item["prescriberlicensenumber"] = item["prescriberlicensenumber"] ? item["prescriberlicensenumber"] : "";
                    const address = item.prescriberaddress1 || item.prescribercity || item.prescriberstate?.toLowerCase() || item.prescriberzipcode 
                    const phone =  this._commonUtil.getPhoneFormat(item?.telephone?.trim());       
                    const orginalPrescriberName = item["prescriberlastname"] + ", " + item["prescriberfirstname"];            
                    return (orginalPrescriberName?.includes(prescriberName) || item["prescriberemail"]?.includes(prescriberName) || item["prescribernpinum"]?.includes(prescriberName) || item["prescriberquickcode"]?.includes(prescriberName) || item["prescriberdeanum"]?.includes(prescriberName) || address?.includes(prescriberName) || phone?.includes(prescriberName) || item["prescriberlicensenumber"]?.includes(prescriberName));
                });
                    this.generatePrescriberWijGrid(this.prescriberSugList);
        } else {
            this.prescriberSugList = this.prescriberSugListSearch;
            this.generatePrescriberWijGrid(this.prescriberSugListSearch); 
        }
    }
     startProgress() {
        this.loading = true;
        this.progressValue = 0;
        const interval = setInterval(() => {
            if (this.prescriberResp) {
                this.progressValue = 100;
                clearInterval(interval);
            } else {
                this.progressValue += 25;
            }
        }, 100);  
    }

    loaderDisplay() {
        this.prescriberResp = true;
        if (this.prescriberResp) {
            setTimeout(()=>{
                this.loading = false;
                if (document.getElementById('loader'))
                    document.getElementById('loader').style.display = 'none';
            }, 200)
        }
    }

    getGlobalSearchPrescriberSuggest() {
        if(this.PrescriberSuggestFilterFG.value['PrescriberName']?.length > 2) {
            let prescriberName = this.PrescriberSuggestFilterFG.get('PrescriberName').value.trim();
            if (document.getElementById('loader'))
                document.getElementById('loader').style.display = 'block';
                this.prescriberResp = false;
                this.startProgress();
                this.PrescriberSuggestFilterFG.get('PrescriberName').setValue(prescriberName);
                let suggData = this._commonServ.getPrescriberSuggest(this.PrescriberSuggestFilterFG.value['PrescriberName'], this.searchFrmPage === "Dash" ? true : false);
                this.getPrescriberSugestData(suggData);
                this.required = false;
        } else {
            this.loaderDisplay();
            this.required = true;
        }
    }

    getPrescriberSugestData(prescObserv: Observable<any>) {
        prescObserv?.pipe(takeUntil(this.unsubscribe$)).subscribe((resp) => {
                if (resp && resp?.length) {
                    this.loaderDisplay();
                    this.prescriberSugList = this.prescriberSugListCopy = this.prescriberSugListSearch = resp;
                    this.focusFirstGrid();
                    if(this.PrescriberSuggestFilterFG?.controls?.['ActivePrescriber']?.value) {
                        this.prescriberSugList  = this.prescriberSugList?.filter((item: any) => {                  
                            return item["activestatusid"] === 1;
                        });
                        this.generatePrescriberWijGrid(this.prescriberSugList);
                    } else this.generatePrescriberWijGrid(this.prescriberSugList);              
                } else {
                    this.modelRef = this._modalService.open(CommonWarnorconfirmPopupComponent, {centered: true, keyboard: false, backdrop: false, windowClass: "large--content"});
                    this.modelRef.componentInstance.IsHeaderText = MsgConfig.Search_Prescriber;                    
                    this.modelRef.componentInstance.warnMsg = "<div><b>Prescriber: </b> <span class='font-bigger text-primary word_break'>"+this.PrescriberSuggestFilterFG.value['PrescriberName']+"</span> not found. <span>Would you like to add?</span></div>";
                    this.modelRef.componentInstance.yesButton = true;
                    this.modelRef.componentInstance.noButton = true;
                    this.modelRef.componentInstance.IsPopUpClosed.pipe(takeUntil(this.unsubscribe$)).subscribe((resp: any) => {
                        if (this.modelRef) {
                            this.modelRef.close();
                            this.modelRef = null;
                        }
                        if (resp) { 
                            this.AddNewPrescriber.emit(this.PrescriberSuggestFilterFG.value["PrescriberName"])
                        }
                        else if (!resp) { 
                            if (this.modelRef) {
                            this.modelRef.close();
                            this.modelRef = null;
                        } }
                    });
                    this.loaderDisplay();
                    this.prescriberSugList = this.prescriberSugListCopy = this.prescriberSugListSearch = [];
                    this.generatePrescriberWijGrid(this.prescriberSugList);
                }
        })
    }

    clearFilters() {
        this.PrescriberSuggestFilterFG.controls['PrescriberName'].patchValue(null);
        this.PrescriberSuggestFilterFG.controls['ActivePrescriber'].patchValue(false);
        this.getActivePrescriberList(false);
        this.focusToFirst();
    }

    closePrescriberModal() {
        this.ClosePrescriberResultModal.emit(true);
        this.clearFilters();
    }
    clearedBySearchIcon() {
        this.required = false;
        this.PrescriberSuggestFilterFG.controls['PrescriberName'].patchValue(null);
        this.generatePrescriberWijGrid(this.prescriberSugListSearch);
        this.focusToFirst();
    }
    focusToFirst(e?) {
        if (document.getElementById("PrescriberName")) {
            this._cdr.detectChanges();
            document.getElementById("PrescriberName").focus();
            if(e) e.preventDefault();
        }
    }

    generatePrescriberWijGrid(sendData) {
        if(sendData && sendData?.length){
            this.prescriberSuggestWJ = new CollectionView(
            sendData?.map((presc: any, i) => {
            const k = {};
            k["RowId"] = i;
            k["Prescriber Name"] = presc?.prescriberlastname +', '+ presc?.prescriberfirstname;
            k["Phone#"] = presc?.telephone && presc?.telephone !== "###" ?  this._commonUtil.getPhoneFormat(presc?.telephone?.trim()) : "--";
            k["Address"] = this.searchFrmPage === "Dash" ? (presc?.PrescriberAddresses[0]?.AddressLine1 + "," + " " + presc?.PrescriberAddresses[0]?.CityName + "," + " " + presc?.PrescriberAddresses[0]?.StateName + "," + " " + presc?.PrescriberAddresses[0]?.ZipCode) : ( presc?.prescriberaddress1 ? presc?.prescriberaddress1 + "," + " " + presc?.prescribercity + "," + " " +  presc?.prescriberstate + "," + " " + presc?.prescriberzipcode : "" );
            k["NPI#"] = presc?.prescribernpinum ? presc?.prescribernpinum : '';
            k["License#"] = presc?.prescriberlicensenumber;
            k["DEA#"] = presc?.prescriberdeanum;
            k["prescriberid"] = presc?.prescriberid;
            k["activestatusid"] = presc?.activestatusid;
             k["fullname"]= presc?.fullname;   
            k["isSelected"] = false;
            return k;
        }));
        } else{
            this.prescriberSuggestWJ = new CollectionView([]);
        }
    }

    getActivePrescriberList(e) {
        if(e) {
            this.prescriberSugListSearch  = this.prescriberSugListSearch?.filter((item: any) => {                  
                return item["activestatusid"] === 1;
            });
            this.prescriberSugList = this.prescriberSugListSearch;
            this.generatePrescriberWijGrid(this.prescriberSugListSearch);
        } else {
            this.prescriberSugListSearch = this.prescriberSugListCopy;
            this.prescriberSugList = this.prescriberSugListSearch;
            this.generatePrescriberWijGrid(this.prescriberSugListCopy);
        }
    }
    ngOnDestroy() {
        sessionStorage.removeItem("fromDrugGrid");
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
        this._commonUtil.close(this.popupId);
        this._storageService.getWijmoGridDataInSession(this.prescriberListwjHeaders,"prescriberSuggestListWj")
    }
}
